// Import all generated product files
import tshirtMc150g from "./generated/tshirt-mc-150g.json";
import tshirtMc190g from "./generated/tshirt-mc-190g.json";
import tshirtMl150g from "./generated/tshirt-ml-150g.json";
import tshirtFemmeMc190g from "./generated/tshirt-femme-mc-190g.json";
import tshirtFemmeRegentMc from "./generated/tshirt-femme-mc-150g.json";
import poloHomme from "./generated/polo-homme.json";
import sweat280g from "./generated/sweat-280g.json";
import sweatCapucheSlam from "./generated/sweat-capuche-slam.json";
import vesteZippeeCalipso from "./generated/veste-zippee-calipso.json";
import softshellHommeFalcon from "./generated/softshell-homme-falcon.json";
import softshellFemmeFalcon from "./generated/softshell-femme-falcon.json";
import vestePolaireHomme from "./generated/veste-polaire-homme.json";
import giletRipstopNoir from "./generated/gilet-ripstop-noir.json";
import giletClasseIi from "./generated/gilet-classe-ii.json";
import parkaKanata4en1Hv from "./generated/parka-kanata-4en1-hv.json";
import pantalonArgileGenouilleres from "./generated/pantalon-argile-genouilleres.json";
import bonnetHat from "./generated/bonnet-hat.json";
import casquetteBuzz from "./generated/casquette-buzz.json";

function products() {
    return [
        tshirtMc150g,
        tshirtMc190g,
        tshirtMl150g,
        tshirtFemmeMc190g,
        tshirtFemmeRegentMc,
        poloHomme,
        sweat280g,
        sweatCapucheSlam,
        vesteZippeeCalipso,
        softshellHommeFalcon,
        softshellFemmeFalcon,
        vestePolaireHomme,
        giletRipstopNoir,
        giletClasseIi,
        parkaKanata4en1Hv,
        pantalonArgileGenouilleres,
        bonnetHat,
        casquetteBuzz,
    ];
}

export default products();

export { products };
